import { defineAsyncComponent } from 'vue'
export default {
  barren: defineAsyncComponent(() => import("/root/front/app/layouts/barren.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/root/front/app/layouts/default.vue").then(m => m.default || m)),
  "onboarding-flow": defineAsyncComponent(() => import("/root/front/app/layouts/onboarding-flow.vue").then(m => m.default || m))
}